/* eslint-disable @typescript-eslint/no-explicit-any */
declare let YT: any;

export function initYoutube() {

    document.querySelectorAll('.js-image-video').forEach($el => {
        const videoId = (<HTMLElement>$el.querySelector('.js-youtube'))?.dataset.id;
        const $openButton = <HTMLButtonElement>$el.querySelector('.js-open-modal');
        const $closeButton = <HTMLButtonElement>$el.querySelector('.js-close-modal');
        const $modal = <HTMLDialogElement>$el.querySelector('.js-modal');
        
        if (videoId && $openButton && $modal) {
            let player: typeof YT.Player | null = null;

            $openButton.addEventListener('click', () => {
                if (!player) {
                    const $iframeContainer = document.createElement('div');
                    $iframeContainer.classList.add('player');
                    $el.querySelector('.js-youtube')?.appendChild($iframeContainer);
                    
                    YT.ready(() => {
                        player = new YT.Player($iframeContainer, {
                            videoId,
                            playerVars: { rel: 0 },
                            events: {
                                'onReady': (event) => {
                                    event.target.playVideo(); // Assurer que le player est prêt avant de jouer
                                }
                            }
                        });
                    });
                } else {
                    player.playVideo();
                }
                $modal.showModal();
            });
            
            $closeButton.addEventListener('click', () => {
                $modal.close();
                player?.stopVideo();
            });
            
            $modal.addEventListener('click', (e: MouseEvent) => {
                const target = e.currentTarget as HTMLDialogElement;
                const { left, top, width, height } = target.getBoundingClientRect();
                
                if (e.clientX < left || e.clientX >= left + width || e.clientY < top || e.clientY >= top + height) {
                    target.close();
                    player?.stopVideo();
                }
            });
        }
    });
}
